export const state = {
    defaultMapName: 'main',
    defaultMap: null,
    maps: [],
    scales: [],
    map3D: null,
    map3DEnabled: false,
    mapTooltipsEnabled: false,
    applyingUserMap: true,
};

export default state;
